//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
export default {
  mixins: [blok],
  props: {
    flipped: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    proseHtml () {
      return this.$storyapi.richTextResolver.render(this.blok.prose)
    },
    textColClass () {
      switch (this.blok.text_column_size) {
        case '1/3':
          return 'md:tw-w-1/3'
        case '2/3':
          return 'md:tw-w-2/3'
        case '2/5':
          return 'md:tw-w-2/5'
        case '3/5':
          return 'md:tw-w-3/5'
        case '1/2':
        default:
          return 'md:tw-w-1/2'
      }
    },
    assetColClass () {
      return 'md:tw-text-center'
    },
    imgClass () {
      const cls = ['tw-inline-block', 'tw-max-h-64', 'md:tw-max-h-full']
      switch (this.blok.img_sizing) {
        case 'full':
          cls.push('md:tw-w-full')
          break
        case '80%':
        default:
          cls.push('md:tw-max-w-[80%]')
          break
      }
      return cls
    },
    titleClass () {
      // Legacy options
      if (!this.blok.title_size) {
        if (this.blok.bigger_title) {
          return ['tw-text-4xl', 'tw-font-bold']
        }
        return ['tw-text-2xl', 'tw-font-semibold']
      }

      const classes = ['tw-text-2xl', 'tw-font-bold']

      if (this.blok.title_size === 'small') {
        classes.push('sm:tw-text-3xl')
      } else {
        classes.push('sm:tw-text-4xl')
      }

      return classes
    },
    proseClass () {
      if (this.blok.prose_size === 'regular') {
        return 'prose-p:tw-text-lg'
      }
      // Default is 1rem, which TW prose uses as default too.
      return ''
    },
    asset () {
      return this.$sb.parseAsset(this.blok.asset) || {}
    },
  },
}
